export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-stream-d61a5bccadad72ef7b2b27218e682661.svg";